import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SocioFondeadorService } from '../../../../services/socio-fondeador.service';
import { HelpersService } from '../../../../services/tools/helpers.service';

@Component({
  selector: 'app-aceptar-retiro-modal',
  templateUrl: './aceptar-retiro-modal.component.html',
  styleUrls: ['./aceptar-retiro-modal.component.scss']
})
export class AceptarRetiroModalComponent implements OnInit {

  public errors: any = {};

  constructor(
    private helperService: HelpersService,
    public socioFondeadorService: SocioFondeadorService,
    public dialogRef: MatDialogRef<AceptarRetiroModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log("ID Retiro: ", this.data.idRetiro);
    console.log("Es ingreso: ", this.data.ingreso);
    
  }

  public cerrar(){
    this.dialogRef.close({retiro:false});
  }

  public aceptar(){
    if (this.data.ingreso){
      console.log("Aceptar Ingreso");
      this.socioFondeadorService.aceptarIngresoSaldo(this.data.idRetiro)
        .subscribe(response => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.helperService.notification('Ingreso aceptado', 'Se ha aceptado el ingreso exitosamente', 'success');
            //Poner dentro del success response
            this.dialogRef.close({retiro:true});
          }
        }, error => {
          if(error.status == 400) {
            this.showServicesErrors(error.json().content);
          }else{
            this.dialogRef.close({retiro:false});
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          
          // se resuelven los errores 403 y 500
          this.helperService.httpGlobalError(error, false);
        });

    }else{
      this.socioFondeadorService.aceptarRetiroSaldo(this.data.idRetiro)
        .subscribe(response => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.helperService.notification('Retiro aceptado', 'Se ha aceptado el retiro exitosamente', 'success');
            //Poner dentro del success response
            this.dialogRef.close({retiro:true});
          }
        }, error => {
          if(error.status == 400) {
            this.showServicesErrors(error.json().content);
          }else{
            this.dialogRef.close({retiro:false});
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
          
          // se resuelven los errores 403 y 500
          this.helperService.httpGlobalError(error, false);
        });
    }
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tools/modals/aceptar-retiro-modal/aceptar-retiro-modal.component.ts